"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _nestedCard = require("./nestedCard.tokens");
var _NestedCardHeader = _interopRequireDefault(require("./NestedCardHeader"));
var _jsxRuntime = require("react/jsx-runtime");
var _NestedCard = function NestedCard(props) {
  var colorTheme = props.colorTheme,
    children = props.children,
    dataCy = props.dataCy;
  var _ref4 = (0, _react.useState)(false),
    _ref5 = _slicedToArray(_ref4, 2),
    expanded = _ref5[0],
    setExpanded = _ref5[1];
  var hasCollapsibleContent = (0, _react.useMemo)(function () {
    return _react.default.Children.toArray(children).some(function (child) {
      return /*#__PURE__*/_react.default.isValidElement(child) && child.type === _NestedCard.CollapsibleContentWrapper;
    });
  }, [children]);
  var hasUncollapsibleContent = (0, _react.useMemo)(function () {
    return _react.default.Children.toArray(children).some(function (child) {
      return /*#__PURE__*/_react.default.isValidElement(child) && (child.type === _NestedCard.UncollapsibleContentWrapper || child.type === _NestedCard.SummaryContent);
    });
  }, [children]);
  (0, _react.useEffect)(function () {
    setExpanded(hasCollapsibleContent);
  }, [hasCollapsibleContent]);
  var toggleExpand = function toggleExpand() {
    setExpanded(!expanded);
  };
  var childrenWithProps = _react.default.Children.map(children, function (child) {
    if (/*#__PURE__*/_react.default.isValidElement(child)) {
      var childNode = child;
      return /*#__PURE__*/_react.default.cloneElement(childNode, {
        toggleExpand: toggleExpand,
        colorTheme: colorTheme,
        hasCollapsibleContent: hasCollapsibleContent,
        expanded: expanded
      });
    }
    return child;
  });
  var className = "nested-card-".concat(props.colorTheme);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Wrapper, {
    colorTheme: colorTheme,
    "data-cy": dataCy,
    className: className,
    expanded: expanded,
    hasUncollapsibleContent: hasUncollapsibleContent,
    children: childrenWithProps
  });
};

/* Nested Card Wrapper  */

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "NestedCard__Wrapper",
  componentId: "sc-1mphmeb-0"
})(["background-color:", ";padding:0 ", ";border-radius:", ";", ""], function (props) {
  return _nestedCard.nestedCardTokens.colorTheme[props.colorTheme].headerBackground;
}, _nestedCard.nestedCardTokens.padding.wrapper, _nestedCard.nestedCardTokens.borderRadius, function (_ref) {
  var expanded = _ref.expanded,
    hasUncollapsibleContent = _ref.hasUncollapsibleContent;
  return expanded || hasUncollapsibleContent ? "padding-bottom: ".concat(_nestedCard.nestedCardTokens.padding.wrapper) : '';
});

/* Nested Card Content  */

var Content = _styledComponents.default.div.withConfig({
  displayName: "NestedCard__Content",
  componentId: "sc-1mphmeb-1"
})(["background-color:", ";padding:", " ", " 0 ", ";", ""], _nestedCard.nestedCardTokens.color.subcontainerBackground, _nestedCard.nestedCardTokens.padding.content, _nestedCard.nestedCardTokens.padding.content, _nestedCard.nestedCardTokens.padding.content, function (_ref2) {
  var isLastElement = _ref2.isLastElement;
  return isLastElement ? "padding-bottom: ".concat(_nestedCard.nestedCardTokens.padding.content, ";") : '';
});

/* Nested Card Summary Content  */

var SummaryContent = (0, _styledComponents.default)(Content).withConfig({
  displayName: "NestedCard__SummaryContent",
  componentId: "sc-1mphmeb-2"
})(["padding-bottom:", ";", ";"], _nestedCard.nestedCardTokens.padding.content, function (_ref3) {
  var expanded = _ref3.expanded;
  return expanded ? "margin-bottom: ".concat(_nestedCard.nestedCardTokens.margin.summaryBottom) : '';
});
var ContentWrapper = function ContentWrapper(props) {
  var children = props.children,
    rest = _objectWithoutProperties(props, ["children"]);
  var numberOfChildren = _react.default.Children.count(children);
  var childrenWithProps = _react.default.Children.map(children, function (child, index) {
    var childNode = child;
    var newProps = _objectSpread({}, rest, {
      isLastElement: index === numberOfChildren - 1
    });
    return /*#__PURE__*/_react.default.cloneElement(childNode, newProps);
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: childrenWithProps
  });
};

/* Nested Content Collapsible Wrapper */

var CollapsibleContentWrapper = function CollapsibleContentWrapper(props) {
  var expanded = props.expanded,
    children = props.children;
  return expanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(ContentWrapper, {
    children: children
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
};
_NestedCard.Header = _NestedCardHeader.default;
_NestedCard.Content = Content;
_NestedCard.UncollapsibleContentWrapper = ContentWrapper;
_NestedCard.CollapsibleContentWrapper = CollapsibleContentWrapper;
_NestedCard.SummaryContent = SummaryContent;
var _default = exports.default = _NestedCard;